<template>
    <v-container class="main-header" :class="{'isCheckout': isCheckout}">
        <v-layout align-center>
            <router-link to="/">
                <img :src="require('../../assets/logo.png')" class="custom-logo" :class="{'isCheckout': isCheckout}" itemprop="logo" />
            </router-link>

            <v-spacer></v-spacer>
            <div class="opening-hours white--text mr-2 hidden-xs-only" v-if="!isCheckout">
                <v-layout align-center>
                    <div class="mr-1">
                        <v-icon color="primary" x-large>mdi-clock-outline</v-icon>
                    </div>
                    <div>
                        <strong class="text-uppercase primary--text">Otevírací doba</strong>
                        <strong>PO - PÁ: 10:00 - 15:00</strong>
                    </div>
                </v-layout>
            </div>
            <v-btn icon @click="drawer = true" color="white" v-if="!isCheckout">
                <v-badge
                        :content="itemsInCart"
                        :value="itemsInCart"
                        color="primary"
                        overlap
                >
                    <span class="icon-shopping-bag"></span>
                </v-badge>
            </v-btn>
        </v-layout>

        <v-navigation-drawer
                temporary
                v-model="drawer"
                :right="true"
                fixed
                width="340"
        >
            <cart-overlay @drawerClose="drawer = false" />
        </v-navigation-drawer>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CartOverlay from '../Cart/CartOverlay'

    export default {
        name: 'MainHeader',
        props: ['isCheckout'],
        data () {
            return {
                drawer: false
            }
        },
        components: {
            CartOverlay
        },
        computed: {
            ...mapGetters([
                'cartProducts'
            ]),
            itemsInCart() {
                let cart = this.cartProducts;
                return cart.reduce((accum, item) => accum + item.qty, 0)
            }
        }
    }
</script>

<style lang="scss">
    .main-header {
        background-color: #000000 !important;
        &.isCheckout {
            padding-top: 0;
            padding-bottom: 0;
        }
        .menu-item {
            a {
                padding: 0 1em;
                font-size: 16px;
                color: #FFFFFF !important;
                text-decoration: none;
                text-transform: uppercase;
                &:hover {
                    opacity: 0.7;
                }
            }
        }
        .custom-logo {
            margin-top: 5px;
            max-width: 180px;
            &.isCheckout {
                max-width: 150px;
            }
        }
        .menu-icon-link {
            border-radius: 7px !important;
        }
        .v-list, .v-menu__content {
            border-radius: 0 !important;
        }
        .v-menu__content {
            max-width: 100% !important;
            width: 100%;
            left: 0 !important;
        }
        .v-chip {
            .v-chip__content {
                cursor: pointer !important;
            }
        }
        .opening-hours {
            strong {
                display: block;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }

    @font-face {
        font-family: 'fontello';
        src: url('../../assets/fonts/fontello.eot?16255092');
        src: url('../../assets/fonts/fontello.eot?16255092#iefix') format('embedded-opentype'),
        url('../../assets/fonts/fontello.woff2?16255092') format('woff2'),
        url('../../assets/fonts/fontello.woff?16255092') format('woff'),
        url('../../assets/fonts/fontello.ttf?16255092') format('truetype'),
        url('../../assets/fonts/fontello.svg?16255092#fontello') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    /* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */
    /* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */
    /*
    @media screen and (-webkit-min-device-pixel-ratio:0) {
      @font-face {
        font-family: 'fontello';
        src: url('../font/fontello.svg?16255092#fontello') format('svg');
      }
    }
    */

    [class^="icon-"]:before, [class*=" icon-"]:before {
        font-family: "fontello";
        font-style: normal;
        font-weight: normal;
        speak: none;

        display: inline-block;
        text-decoration: inherit;
        width: 1em;
        margin-right: .2em;
        text-align: center;
        /* opacity: .8; */

        /* For safety - reset parent styles, that can break glyph codes*/
        font-variant: normal;
        text-transform: none;

        /* fix buttons height, for twitter bootstrap */
        line-height: 1em;

        /* Animation center compensation - margins should be symmetric */
        /* remove if not needed */
        margin-left: .2em;

        /* you can be more comfortable with increased icons size */
        /* font-size: 120%; */

        /* Font smoothing. That was taken from TWBS */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        /* Uncomment for 3D effect */
        /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
    }

    .icon-shopping-bag:before {     font-size: 28px;content: '\e802'; } /* '' */
</style>
